import { Modal, Input } from "antd";
import { useEffect, useRef } from "react";
import { formatVtoVisual } from "../../../../../utils/formatVtoVisual";
import {
  normalizarLote,
  normalizarVto,
} from "../../../../../utils/normalizarLoteVto";

const ModalLoteVto = ({
  open,
  onCancel,
  onConfirm,
  loteInput,
  setLoteInput,
  vtoInput,
  setVtoInput,
  nombreArticulo,
}) => {
  const loteRef = useRef(null);

  useEffect(() => {
    if (open) {
      // pequeño delay para asegurar que el modal ya renderizó
      setTimeout(() => {
        loteRef.current?.focus();
      }, 100);
    }
  }, [open]);

  const handleChangeLote = (e) => {
    setLoteInput(normalizarLote(e.target.value));
  };

  const handleChangeVto = (e) => {
    setVtoInput(normalizarVto(e.target.value));
  };

  const handleCerrarModalLote = () => {
    setLoteInput("");
    setVtoInput("");
    onCancel();
  };

  return (
    <Modal
      destroyOnHidden={true}
      title={
        <div>
          <div>Registrar Lote y VTO</div>
          {nombreArticulo && (
            <div style={{ fontSize: 14, fontWeight: "normal", opacity: 0.7 }}>
              {nombreArticulo}
            </div>
          )}
        </div>
      }
      open={open}
      onCancel={handleCerrarModalLote}
      okText="Confirmar"
      cancelText="Cancelar"
      onOk={onConfirm}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          marginTop: 8,
        }}
      >
        <Input
          ref={loteRef}
          placeholder="Lote"
          value={loteInput}
          onChange={handleChangeLote}
          maxLength={25}
        />

        <Input
          placeholder="Fecha VTO (YYYY-MM-DD)"
          value={formatVtoVisual(vtoInput)}
          onChange={handleChangeVto}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={10}
        />
      </div>
    </Modal>
  );
};

export default ModalLoteVto;
